<section>
  <!-- header part inlcuding search and list of all entries -->
  <h2>Alles zur Webseite</h2>
  <p>
    Willkommen auf der Diskussionsseite für die Webseite!<br />
    Dies ist für technische Infos, die sich auf die Webseite beziehen. Wenn ihr
    Infos zur Familie teilen wollt, geht bitte zu
    <a routerLink="/faminfos" routerLinkActive="active">Familieninfos</a>. Wenn
    es sich auf eine bestimmte Person bezieht, geht bitte zur
    <a routerLink="/ancestors" routerLinkActive="active">Stammfolge</a>, wählt
    die entsprechende Person aus, und klickt auf den Button Diskussion in den
    Personeninfos oder sucht auf
    <a routerLink="/discussions" routerLinkActive="active"
      >Diskussionen zur Stammfolge</a
    >
    nach einer bereits existierende Diskussion.<br /><br />
    Jeder Nutzer kann immer nur seinen eigenen Beiträge bearbeiten oder löschen.
    Sollten euch Beiträge auffallen, die problematisch sind, informiert uns
    bitte.
  </p>
  <div class="subheader">
    <div>
      <button (click)="showPopUp('add', this.entry)">
        Eigenen Beitrag erstellen
      </button>
    </div>
    <div>
      <h3>Vorhandene Beiträge</h3>
      <input
        type="text"
        placeholder="Durchsuche Liste nach Autor oder Info..."
        (input)="filterEntries($event)"
        class="searchInput"
      />
      <ul class="indexList">
        @for (info of filteredInfos; track info.id) {
          <li (click)="goToInfo(info.id)">Beitrag zu: {{ info.title }}</li>
        }
      </ul>
    </div>
  </div>
  <!-- single entry containers -->
  @for (info of infos; track info.id; let i = $index) {
    <div class="entryContainer">
      <div class="entryHeader">
        <h2 [id]="info.id">{{ info.title }}</h2>
        @if (!info.isHidden) {
          <img
            src="assets/images/arrow_up.png"
            alt="Show"
            (click)="toggleVisibility(i)"
          />
        }

        @if (info.isHidden) {
          <img
            src="assets/images/arrow_down.png"
            alt="Hide"
            (click)="toggleVisibility(i)"
          />
        }
      </div>

      <div [hidden]="info.isHidden">
        <div [innerHTML]="info.content" class="entryContent"></div>
        <div class="entryImagesContainer">
          @for (image of info.images; track $index) {
            <div>
              <img
                (click)="showPopUp('image', image.original)"
                loading="lazy"
                [src]="image.thumbnail"
                alt="Info Image"
              />
            </div>
          }
        </div>
        <div>
          @for (pdf of info.pdfs; track $index) {
            <div>
              <a [href]="pdf.url" target="_blank" rel="noopener">{{
                pdf.name
              }}</a>
            </div>
          }
        </div>
        <div class="entryMeta">
          <p>Author: {{ info.author_name }}</p>
          <p>
            <small>Erstellt am: {{ info.created_at | date: "short" }}</small
            ><br />
            <small
              >Zuletzt bearbeitet: {{ info.updated_at | date: "short" }}</small
            >
          </p>
          <div class="editOrDeleteContainer">
            @if (info.author_email === userEmail) {
              <img
                src="assets/images/edit_24dp_RGBA(100, 16, 32)_FILL0_wght400_GRAD0_opsz24.png"
                (click)="showPopUp('edit', info)"
              />
            }

            @if (info.author_email === userEmail) {
              <img
                src="assets\images\delete_24dp_RGBA(100, 16, 32)_FILL0_wght400_GRAD0_opsz24.png"
                (click)="showPopUp('delete', info)"
              />
            }
          </div>
        </div>
        <!-- comment section of single entry containers -->
        @if (comments[info.id]) {
          <div class="comments">
            <h4>Kommentare:</h4>
            @for (comment of comments[info.id]; track comment.id) {
              <div class="singleComment" class="entryContent">
                <div>
                  <p>{{ comment.content }}</p>
                  <small
                    >Von: {{ comment.author_name }} am
                    {{ comment.created_at | date: "short" }}</small
                  >
                </div>
                <div class="editOrDeleteContainer">
                  @if (comment.author_email === userEmail) {
                    <img
                      src="assets/images/edit_24dp_RGBA(100, 16, 32)_FILL0_wght400_GRAD0_opsz24.png"
                      (click)="showPopUp('editComment', comment)"
                    />
                  }

                  @if (comment.author_email === userEmail) {
                    <img
                      src="assets\images\delete_24dp_RGBA(100, 16, 32)_FILL0_wght400_GRAD0_opsz24.png"
                      (click)="showPopUp('deleteComment', comment)"
                    />
                  }
                </div>
              </div>
            }
          </div>
        }

        <div class="newComments">
          <textarea
            [(ngModel)]="newComment[info.id]"
            placeholder="Neuen Kommentar hinzufügen..."
            (keyup.enter)="addComment(info.id, newComment[info.id])"
          ></textarea>
          <button (click)="addComment(info.id, newComment[info.id])">+</button>
        </div>
      </div>
    </div>
  }

  <!-- PopUp container for all popups on this site -->
  <div
    id="popUpContainer"
    class="popUpInfoContainer dNone"
    (click)="hidePopUp()"
  >
    <!-- PopUp box for adding or editing an entry -->
    @if (entry) {
      <div id="popUp" class="editEntry" (click)="$event.stopPropagation()">
        <form (ngSubmit)="saveEntry()" enctype="multipart/form-data">
          <div class="entryHeader column">
            <h4>
              {{ entry.id ? "Beitrag bearbeiten" : "Neuen Beitrag erstellen" }}
            </h4>
            <h5>Betreff (bitte ausfüllen):</h5>
            <input
              class="entryInput"
              type="text"
              placeholder="Betreff"
              [(ngModel)]="entry.title"
              name="title"
              required
            />
          </div>

          <div>
            <h5>Inhalt (bitte ausfüllen):</h5>
            <quill-editor
              [(ngModel)]="entry.content"
              name="content"
              placeholder="Dein Beitrag"
            ></quill-editor>
          </div>
          <div class="divider"></div>
          <div>
            <h4>Bilder:</h4>
            <h5>Vorhandene Bilder</h5>
            <div class="deleteImageContainer">
              @for (image of entry.images; track $index) {
                <div class="deleteImage">
                <img
                  [src]="image.thumbnail"
                  alt="Image"
                  width="100"
                  [ngClass]="{
                    'grayed-out': isImageDeleted(image.original, entry),
                  }"
                />
                <button
                  type="button"
                  (click)="removeImageByUrl(image.original)"
                >
                  Bild löschen
                </button>
              </div>
              }
              
            </div>
            <h5 for="images">Bilder hochladen (max. 4):</h5>
            @for (index of [1, 2, 3, 4]; track index) {<div
              class="image-upload-container"
            >
              @if (isImageSlotAvailable(index)) {
                <div class="upload-image-field">
                  <input
                    type="file"
                    [id]="'image' + index"
                    (change)="onImageFileChange($event, index)"
                    accept=".jpg,.png"
                  />
                </div>
              }
            </div>}
            @if (imageFiles.length > 0) {
              <div>
                <h5>Neue Bilder:</h5>
                <ul>
                  @for (file of imageFiles; track $index) {<li>{{ file.name }}</li>}
                </ul>
              </div>
            }
          </div>
          <div>
            <div class="divider"></div>
            <h4>PDFs:</h4>

            <!-- Vorhandene PDFs -->
            <h5>Vorhandene PDFs</h5>
            <div class="deletePdfContainer">
              @for (pdf of entry.pdfs; track $index) {
                <div
                  class="deletePdf"
                  [ngClass]="{ 'grayed-out': isPdfDeleted(pdf.url) }"
                >
                  <a [href]="pdf.url" target="_blank" rel="noopener">{{
                    pdf.name
                  }}</a>

                  <button type="button" (click)="removePdfByUrl(pdf.url)">
                    PDF löschen
                  </button>
                </div>
              }
            </div>

            <!-- Neue PDFs -->
            <h5>Neue PDFs hochladen (max. 4):</h5>
            @for (index of [1, 2, 3, 4]; track index) {
              <div class="pdf-upload-container">
                @if (isPdfSlotAvailable(index)) {
                  <div>
                    <!-- Falls noch kein PDF hochgeladen wurde → Button statt Input -->
                    <div>
                      <input
                        type="file"
                        [id]="'pdf_' + index"
                        (change)="onPdfFileChange($event, index)"
                        accept=".pdf"
                      />
                    </div>
                  </div>
                }
              </div>
            }
            @if (pdfFiles.length > 0) {
              <div>
                <h5>Neue PDFs:</h5>
                <ul>
                  @for (pdf of pdfFiles; track $index; let i = $index) {
                    <li class="newList">
                      {{ pdf.file.name }}
                      <input
                        type="text"
                        [(ngModel)]="pdf.customName"
                        placeholder="andere Namen vergeben"
                      />
                      <button type="button" (click)="removeNewPdf(i)">
                        Entfernen
                      </button>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>

          <div class="buttonContainer">
            <button type="button" (click)="hidePopUp()">Abbrechen</button>
            <button
              type="submit"
              [disabled]="!entry.content || imageFiles.length > 4"
            >
              Speichern
            </button>
          </div>
        </form>
      </div>
    }

    <!-- PopUp box for showing image -->
    @if (this.showImageUrl) {
      <div class="showImage">
        <img [src]="this.showImageUrl" />
      </div>
    }

    <!-- PopUp box for deleting an entry -->
    @if (entryToDelete) {
      <div class="editEntry" (click)="$event.stopPropagation()">
        <h3>Beitrag löschen</h3>
        <p>Möchtest du diesen Beitrag löschen?</p>
        <div class="buttonContainer">
          <button (click)="hidePopUp()">Abbrechen</button>
          <button (click)="deleteEntry()">Löschen</button>
        </div>
      </div>
    }

    <!-- PopUp box for editing a comment -->
    @if (commentToUpdate) {
      <div class="editEntry" (click)="$event.stopPropagation()">
        <form (ngSubmit)="saveComment()">
          <div class="entryHeader column">
            <h5>Kommentar bearbeiten</h5>
            <textarea
              [(ngModel)]="commentToUpdate.content"
              name="content"
              class="editComment"
            ></textarea>
          </div>
          <div class="divider"></div>
          <div class="buttonContainer">
            <button type="button" (click)="hidePopUp()">Abbrechen</button>
            <button type="submit" [disabled]="!commentToUpdate.content">
              Speichern
            </button>
          </div>
        </form>
      </div>
    }

    <!-- Popup box for deleting a comment -->
    @if (commentToDelete) {
      <div class="editEntry" (click)="$event.stopPropagation()">
        <h3>Kommentar löschen</h3>
        <p>Möchtest du diesen Kommentar löschen?</p>
        <div class="buttonContainer">
          <button (click)="hidePopUp()">Abbrechen</button>
          <button (click)="deleteComment()">Löschen</button>
        </div>
      </div>
    }
  </div>
</section>

<app-scroll-to-top-button></app-scroll-to-top-button>
